exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-upload-list__item-name [class^=el-icon]{display:none}.el-upload-list__item-name{margin-right:25px}.el-upload-list__item{font-size:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-72793775","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/sale_notes/partials/dispatch_status.vue
// module id = EuS4
// module chunks = 0